export default __webpack_public_path__ + "static/media/parts-manufacturing.2ec8f937.png";